import React, { useState, useEffect } from "react";
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import Eje from './Eje';
import Region from './Region';
import plus from './plus-sign.png';
import scroll from './scroll.png';
import './Filtros.css'
import Accordion from 'react-bootstrap/Accordion'
import arrow from './arrow.png';


function Ejes(props) {

    let [selector, setSelector] = useState(true)

    const [newProps, setNewProps] = useState(props);

    const [leyendaBrechas, setLeyendaBrechas] = useState([]);

    //const colores = ["#e89b37","#4d8dd7", "#bcbdc0", '#b3de69', '#fccde5',"#e89b37"] //
    //const coloresLinea = ['#fb8072','#8dd3c7','#36454f']
    // const colores = ['#ff7f00','#377eb8','#999999','#4daf4a','#984ea3','#ffff33','#f781bf'] // 
    // const coloresLinea = ['#e41a1c','#a65628','#36454f']
    const colores = ['#f781bf', '#4daf4a', '#984ea3', '#e41a1c', '#36454f', '#ffff33', '#a65628'] // 
    const coloresLinea = ['#ff7f00', '#999999', '#377eb8']
    const nombresColores = [{ color: "#4d8dd7", nombre: "Azul:" }, { color: "#e89b37", nombre: "Naranja:" }, { color: "#bcbdc0", nombre: "Gris:" }]

    if (props !== newProps) {
        setNewProps(props);
    }

    function obtenerDatos(eje, region) {
        let year = eje.year, dim = eje.dimension, type = region.tipo, mun = region.municipio, depto = region.departamento
        if (type == "totalDept") {
            let data = []
            let check = false
            props.estado.deptos.forEach(deptoi => {
                if (props.estado.data[dim][deptoi][year]["depto"]) {
                    data.push(...props.estado.data[dim][deptoi][year]["depto"])
                }
                else {
                    check = true
                }
            });
            if (check) {
                props.updateData.fetchDeptData(year, dim)
            }
            if (data.length == 0) {
                return false
            }
            return data
        }
        else if (type == "totalPDET") {
            let data = []
            let check = false
            props.estado.PDET.forEach(deptoi => {
                if (props.estado.dataPDET[dim][deptoi.nombre][year]) {
                    data.push(...props.estado.dataPDET[dim][deptoi.nombre][year])
                }
                else {
                    check = true
                }
            });
            if (check) {
                props.updateData.fetchPDETData(year, dim)
            }
            if (data.length == 0) {
                return false
            }
            return data
        }
        else if (type == "totalMun") {
            if (props.estado.data[dim][depto][year]["mun"]) {
                return props.estado.data[dim][depto][year]["mun"]
            }
            else {
                props.updateData.fetchMunData(depto, year, dim)
                return false
            }
        }
        else if (type == "PDET") {
            if (props.estado.dataPDET[dim][depto][year]) {
                let value = props.estado.dataPDET[dim][depto][year]
                if (value && value.length > 0) {
                    value = value[0]
                    if (value && value.attributes) {
                        return value.attributes
                    }
                }
                else {
                    return false
                }
            }
            else {
                props.updateData.fetchPDETData(year, dim)
                return false
            }
        }
        else if (type == "dept") {
            if (props.estado.data[dim][depto][year]["depto"]) {
                let value = props.estado.data[dim][depto][year]["depto"]
                if (value && value.length > 0) {
                    value = value[0]
                    if (value && value.attributes) {
                        return value.attributes
                    }
                }
                return false
            }
            else {
                props.updateData.fetchDeptData(year, dim)
                return false
            }
        }
        else if (type == "mun") {
            if (props.estado.data[dim][depto][year]["mun"]) {
                let value = props.estado.data[dim][depto][year]["mun"]
                if (value) {
                    value = value.find(item => item.attributes.municipality == mun)
                    if (value && value.attributes) {
                        return value.attributes
                    }
                }
                return false
            }
            else {
                props.updateData.fetchMunData(depto, year, dim)
                return false
            }
        }
        return null
    }

    function combinarDatos(datos) {
        let porRegion = {}
        datos.forEach(item => {
            if (porRegion[item.divipola]) {
                porRegion[item.divipola].push(item)
            }
            else {
                porRegion[item.divipola] = [item]
            }
        })
        return porRegion
    }


    useEffect(() => {
        if (props.ejes.ejes.length < 2) {
            let eje1 = {
                id: 1, year: 2019, tipo: "dept", vari: {
                    name: "Cobertura en educación (total)", value: "total_net_coverage", brechas: [], range: [0, 100], unit: "%", limits: [95, 85],
                    titulos: ["Alta cobertura", "Media cobertura", "Baja cobertura"],
                    descripciones: [
                        "Tienen el reto de mantener o ampliar la oferta educativa hasta alcanzar la universalidad en el acceso, al igual que enfocar su política pública en mejorar la calidad educativa por medio del análisis de resultados de las pruebas estandarizadas de los estudiantes del municipio.",
                        "Tienen el desafío de seguir ampliando su oferta educativa para lograr la universalidad en el acceso. Las autoridades deben caracterizar a aquella población que se queda por fuera del sistema educativo (por ejemplo, la condición socioeconómica según Sisbén y zona geográfica), para así ampliar la oferta educativa de forma específica.",
                        "Tienen el desafío de ampliar su oferta educativa para cubrir las necesidades de la demanda. Su política pública debe ir enfocada en la creación de cupos educativos por medio de inversión en zonas críticas donde el acceso a cupos puede ser desafiante, como poblaciones más vulnerables y zonas rurales dispersas (si aplica)."
                    ],
                    descripcion: "El acceso a la educación puede medirse a partir del indicador de cobertura neta, el cual da cuenta de la relación que existe entre el número de estudiantes matriculados en un nivel educativo que tienen la edad teórica para cursarlo y el total de la población correspondiente a esa misma edad en un periodo específico (Ministerio de Educación Nacional, 2013)."
                }, dimension: "BD_25_CNE", orgRange: [0, 100], orgLimits: [95, 85], orgDesc: ""
            }
            let eje2 = {
                "id": 2, "year": 2018, "tipo": "dept", "vari": {
                    "name": "Tasa de analfabetismo", "value": "rate_illiteracy", brechas: [], "range": [0, false], calc: 100, unit: "%", limits: [7.5, 10.5],
                    titulos: ["Bajo analfabetismo", "Analfabetismo medio", "Alto analfabetismo"],
                    descripciones: [
                        "Requiere fortalecer los modelos de alfabetización para poder reducir el analfabetismo funcional y así lograr que sus habitantes desarrollen de manera integral sus habilidades para leer y escribir, y avanzar en el cierre de brechas en términos de alfabetización.",
                        "Requiere fortalecer los procesos de caracterización de la población, para determinar las necesidades que existen por parte de grupos poblacionales específicos y así implementar estrategias focalizadas de alfabetización.",
                        "Requiere direccionar los esfuerzos y estrategias a la atención de la población mayor a 15 años que presente esta condición. Implica la disminución del ausentismo escolar, principalmente en los primeros grados educativos, lo que facilitará la generación de competencias en lectoescritura por parte de la población."
                    ],
                    descripcion: "El analfabetismo se define como la ausencia de competencias para poder leer y escribir, y su incidencia se mide a través de la tasa de analfabetismo, la cual corresponde al porcentaje de la población que no sabe leer ni escribir, ni puede comprender un texto sencillo y corto sobre su vida cotidiana (MEN, 2013)."
                }, "dimension": "BD_28_ANA", "orgRange": [0, false], orgLimits: [7.5, 10.5], orgDesc: ""
            }
            let eje3 = {
                "id": 3, "year": 2018, "tipo": "dept", "vari": {
                    "name": "Índice de pobreza multidimensional", "value": "ipm", brechas: [], "range": [0, false], calc: 100, unit: "", limits: [35, 65],
                    titulos: ["IPM bajo", "IPM medio", "IPM alto"],
                    descripciones: [
                        "Requieren promover el acceso a empleos de calidad que garanticen la formalidad de los trabajadores y trabajadoras y les permita adquirir capacidades en generación de ingresos, al igual que reducir las brechas de género en materia de ingreso, autonomía financiera y distribución de los recursos.",
                        "Requieren buscar el desarrollo de las zonas rezagadas a través de proyectos e intervenciones regionales y subregionales de impacto, y del impulso a la coordinación y la asociatividad territoriales; es decir, buscar conectar territorios. ",
                        "Tienen como desafío principal realizar inversiones en programas de mejoramiento de vivienda que conlleven una mejora de las deficiencias en la estructura y en la disponibilidad de servicios públicos domiciliarios. Requieren inversión en infraestructura educativa y acciones para mejorar el acceso a aseguramiento en salud."
                    ],
                    descripcion: "El Índice de Pobreza Multidimensional (IPM) es la medición de la pobreza de manera directa, a través de cinco dimensiones y quince indicadores: 1. Condiciones educativas: analfabetismo y bajo logro educativo. 2. Condiciones de la niñez y juventud: inasistencia escolar, rezago escolar, barreras de acceso a servicios de cuidado de primera infancia, y trabajo infantil. 3. Trabajo: trabajo informal y desempleo de larga duración. 4. Salud: sin aseguramiento a salud y barreras de acceso a salud dada una necesidad. 5. Condiciones de la vivienda y servicios públicos: sin acceso a fuente de agua mejorada, inadecuada eliminación de excretas, material inadecuado de pisos, material inadecuado de paredes y hacinamiento crítico."
                }, "dimension": "BD_11_IPM", "orgRange": [0, false], orgLimits: [35, 65], orgDesc: ""
            }
            let eje5 = {
                year: 2020, tipo: "dept", vari: {
                    "name": "Razón de mortalidad materna (por cien mil nacidos vivos)",
                    "value": "rate_cienmilhab",
                    "mostrarBrechas": true,
                    "brechas": [{
                        "nombre": "Etnia",
                        "categorias": [{
                            "value": "indigena",
                            "nombre": "Indígena"
                        }, {
                            "value": "narp",
                            "nombre": "NARP"
                        }, {
                            "value": "ninguno",
                            "nombre": "No étnica"
                        }]
                    },
                    {
                        "nombre": "Zona",
                        "categorias": [{
                            "value": "rural",
                            "nombre": "Rural"
                        }, {
                            "value": "urbano",
                            "nombre": "Urbano"
                        }, {
                            "value": "sin_inform",
                            "nombre": "Sin  información"
                        }]
                    },
                    {
                        "nombre": "Edad",
                        "categorias": [{
                            "value": "50_54_anios",
                            "nombre": "de 50-54 Años"
                        },
                        {
                            "value": "45_49_anios",
                            "nombre": "de 45-49 Años"
                        },
                        {
                            "value": "40_44_anios",
                            "nombre": "de 40-44 Años"
                        },
                        {
                            "value": "35_39_anios",
                            "nombre": "de 35-39 Años"
                        },
                        {
                            "value": "30_34_anios",
                            "nombre": "de 30-34 Años"
                        },
                        {
                            "value": "25_29_anios",
                            "nombre": "de 25-29 Años"
                        },
                        {
                            "value": "20_24_anios",
                            "nombre": "de 20-24 Años"
                        },
                        {
                            "value": "15_19_anios",
                            "nombre": "de 15-19 Años"
                        },
                        {
                            "value": "10_14_anios",
                            "nombre": "de 10-14 Años"
                        }
                        ]
                    }
                    ],
                    "range": [0, false],
                    "calc": 1,
                    "unit": "",
                    "limits": [50, 150],
                    "titulos": ["Baja mortalidad materna", "Media mortalidad materna", "Alta mortalidad materna"],
                    "descripciones": [
                        "Verificar subregistro en la fuente de información; es necesario gestionar y hacer seguimiento a la información reportada y registrada.",
                        "Como principal reto, fortalecer los esfuerzos para lograr la garantía del acceso a servicios de salud para gestantes (atenciones prenatales, del parto y del puerperio, y la anticoncepción posparto).",
                        "Incluir en las políticas públicas en salud materna acciones de gestión de riesgo relacionadas con la disponibilidad, accesibilidad, aceptabilidad, calidad y uso efectivo de los servicios de salud para la atención y el tratamiento de las eventuales complicaciones que se pueden presentar."
                    ],
                    "descripcion": "La Razón de Mortalidad Materna (RMM) es uno de los indicadores más importantes en términos de atención integral en salud materna. Representa el número de mujeres fallecidas por causas relacionadas con el embarazo y el parto por cada 100.000 nacidos vivos de acuerdo con el municipio de residencia.",
                    "fuente": "Estadísticas vitales, consultadas en bodega de datos del SISPRO, julio de 2021."
                }, dimension: "BD_16_RMM", orgRange: [0, false], orgLimits: [50, 150], orgDesc: ""
            }
            let region1 = { "id": 0, "tipo": "mun", "departamento": "Valle del Cauca", "municipio": "Buenaventura", "divipola": "00000", "color": "#2ccce4" }
            let region2 = { "id": 1, "tipo": "mun", "departamento": "Cauca", "municipio": "Santander de Quilichao", "divipola": "00000", "color": "#ba68c8" }
            let region3 = { "id": 2, "tipo": "dept", "departamento": "Valle del Cauca", "municipio": "TODOS", "divipola": "00000", "color": "#37d67a" }
            let region4 = { "id": 3, "tipo": "dept", "departamento": "Cauca", "municipio": "TODOS", "divipola": "00000", "color": "#ff8a65" }
            let region6 = { "id": 5, "tipo": "PDET", "departamento": "Total Nacional", "municipio": "Total Nacional", "divipola": "00000", "color": "#dce775" }
            let ejes = [eje1, eje2, eje3]
            props.actualizarFullEjes(ejes, [region1, region2, region3, region4], eje5, region6)
        }
    }, [])

    function justify(str, len) {

        var re = RegExp("(?:\\s|^)(.{1," + len + "})(?=\\s|$)", "g");
        var res = [];
        var finalResult = [];
        var m

        while ((m = re.exec(str)) !== null) {
            res.push(m[1]);
        }

        for (var i = 0; i < res.length - 1; i++) {
            if (res[i].indexOf(' ') != -1) {
                while (res[i].length < len) {
                    for (var j = 0; j < res[i].length - 1; j++) {
                        if (res[i][j] == ' ') {
                            res[i] = res[i].substring(0, j) + " " + res[i].substring(j);
                            if (res[i].length == len) break;
                            while (res[i][j] == ' ') j++;
                        }
                    }
                }
            }
            finalResult.push(res[i]);
        }

        finalResult.push(res[res.length - 1]);

        return finalResult.join('\n');

    }

    function ajustarMaximoMinimoEjesMismaCategoria(ejes) {
        var ref = {};
        // iterate over array and generate result object
        var res = ejes.reduce(function (arr, o) {
            // check index defined in `ref`
            if (ref.hasOwnProperty(o.vari.name))
                // if defined then push value to that index
                arr[ref[o.vari.name]].push(o);
            // else add index and push new array as element
            else {
                ref[o.vari.name] = arr.length;
                arr.push([o]);
            }
            // return the array reference
            return arr;
            // set initial valaue as empty array
        }, []);
        let ejesVisibles = []
        res.forEach((tipo) => {
            if (tipo.length > 1) {
                var max = -Infinity;
                var min = Infinity;
                tipo.forEach((eje) => {
                    if (eje.orgRange[0] < min) min = eje.orgRange[0];
                    if (eje.orgRange[1] > max) max = eje.orgRange[1];
                })
                tipo.forEach((eje) => {
                    eje.orgRange[0] = min;
                    eje.orgRange[1] = max;
                })
                ejesVisibles.push({ category: tipo[0].vari.name, min: min, max: max, vari: tipo[0].vari })
            }
            else {
                ejesVisibles.push({ category: tipo[0].vari.name, min: tipo[0].orgRange[0], max: tipo[0].orgRange[1], vari: tipo[0].vari })
            }
        })
        return ejesVisibles
    }

    useEffect(() => {
        // Grafica de brechas sellecionada
        if (props.tipoGrafica == "brechas" && props.ejes.regionBrechas && props.ejes.ejeBrechas) {

            // Puntos a graficar
            let newDatos = []

            // Lineas de fondo
            let datosLineas = []

            // Brechas
            let ejes = []

            // Leyenda 
            let leyenda = []

            // Nivel nacional seleccionado
            if (props.ejes.regionBrechas.tipo == "PDET") {

                // Agrgar brecha departamentos
                ejes.push({ category: "Departamentos", labelName: "Sin información", color: colores[1] })

                // Obtener datos de todos los departamentos
                let reg2 = { id: 0, tipo: "totalDept", departamento: "Total Nacional", municipio: "Total Nacional", divipola: "00000", data: [], color: "#4d8dd7" }
                let datosDept = obtenerDatos(props.ejes.ejeBrechas, reg2)

                // Agregar departamentos con datos
                if (datosDept) {
                    datosDept = datosDept.filter(item => item != undefined).filter(item => item.attributes != undefined).map(item => item.attributes)
                    let serieDepts = []
                    datosDept.forEach(dato => {
                        if (dato[props.ejes.ejeBrechas.vari.value] != null) {
                            newDatos.push([{ ...dato, category: "Departamentos", value: dato[props.ejes.ejeBrechas.vari.value], color: colores[1], name: dato.department }])
                            serieDepts.push({ ...dato, category: "Departamentos", value: dato[props.ejes.ejeBrechas.vari.value], color: colores[1], name: dato.department })
                        }
                    })
                    datosLineas.push(serieDepts)
                }
            }

            // Nivel departamental seleccionado
            else if (props.ejes.regionBrechas.tipo == "dept") {

                // Agrgar brecha municipios
                ejes.push({ category: "Municipios", labelName: "Sin información", color: colores[1] })

                // Obtener datos de todos los municipios y el departamento
                let reg2 = { ...props.ejes.regionBrechas, tipo: "totalMun" }
                let datosDept = obtenerDatos(props.ejes.ejeBrechas, props.ejes.regionBrechas)
                let datosMun = obtenerDatos(props.ejes.ejeBrechas, reg2)

                // Agregar municipios con datos
                if (datosMun) {
                    datosMun = datosMun.filter(item => item != undefined).filter(item => item.attributes != undefined).map(item => item.attributes)
                    let serieMuns = []
                    datosMun.forEach(dato => {
                        if (dato[props.ejes.ejeBrechas.vari.value] != null) {
                            newDatos.push([{ ...dato, category: "Municipios", value: dato[props.ejes.ejeBrechas.vari.value], color: colores[1], name: dato.municipality }])
                            serieMuns.push({ ...dato, category: "Municipios", value: dato[props.ejes.ejeBrechas.vari.value], color: colores[1], name: dato.municipality })
                        }
                    })
                    datosLineas.push(serieMuns)
                }


                if (datosDept) {
                    // Agregar linea departamento
                    if (datosDept[props.ejes.ejeBrechas.vari.value] != null) {

                        // linea
                        let colorLinea = coloresLinea[0]
                        let datosLineaDept = [
                            { ...datosDept, category: "Municipios", value: datosDept[props.ejes.ejeBrechas.vari.value], color: colorLinea, name: datosDept.department },
                        ]

                        // Extra brechas
                        props.ejes.ejeBrechas.vari.brechas.forEach((brecha, i) => {
                            datosLineaDept.push({ ...datosDept, category: brecha.nombre, value: datosDept[props.ejes.ejeBrechas.vari.value], color: colorLinea, name: datosDept.department })
                            let serieBrecha = []
                            brecha.categorias.forEach(categoria => {
                                newDatos.push([{ ...datosDept, category: brecha.nombre, value: datosDept[props.ejes.ejeBrechas.vari.value + "_" + categoria.value], color: colores[i + 2], name: categoria.nombre }])
                                serieBrecha.push({ ...datosDept, category: brecha.nombre, value: datosDept[props.ejes.ejeBrechas.vari.value + "_" + categoria.value], color: colores[i + 2], name: categoria.nombre })
                            })
                            datosLineas.push(serieBrecha)
                        });

                        newDatos.push(datosLineaDept)
                        if (datosLineaDept.length > 0) {
                            leyenda.push({ color: datosLineaDept[0].color, name: datosLineaDept[0].name, value: datosLineaDept[0].value })
                        }

                    }
                }

            }
            else {
                // Obtener datos del municipio y del departamento
                let reg2 = { ...props.ejes.regionBrechas, tipo: "dept" }
                let datosDept = obtenerDatos(props.ejes.ejeBrechas, reg2)
                let datosMun = obtenerDatos(props.ejes.ejeBrechas, props.ejes.regionBrechas)

                if (datosDept) {
                    // Agregar linea departamento
                    if (datosDept[props.ejes.ejeBrechas.vari.value] != null) {

                        // linea
                        let colorLinea = coloresLinea[0]
                        let datosLineaDept = []

                        // Extra brechas
                        props.ejes.ejeBrechas.vari.brechas.forEach((brecha, i) => {
                            datosLineaDept.push({ ...datosDept, category: brecha.nombre, value: datosDept[props.ejes.ejeBrechas.vari.value], color: colorLinea, name: datosDept.department })
                        });
                        newDatos.push(datosLineaDept)
                        if (datosLineaDept.length > 0) {
                            leyenda.push({ color: datosLineaDept[0].color, name: datosLineaDept[0].name, value: datosLineaDept[0].value })
                        }
                    }
                }

                if (datosMun) {
                    // Agregar linea municipio
                    if (datosMun[props.ejes.ejeBrechas.vari.value] != null) {

                        // linea
                        let colorLinea = coloresLinea[1]
                        let datosLineaMun = []

                        // Extra brechas
                        props.ejes.ejeBrechas.vari.brechas.forEach((brecha, i) => {
                            datosLineaMun.push({ ...datosMun, category: brecha.nombre, value: datosMun[props.ejes.ejeBrechas.vari.value], color: colorLinea, name: datosMun.municipality })
                            let serieBrecha = []
                            brecha.categorias.forEach(categoria => {
                                newDatos.push([{ ...datosMun, category: brecha.nombre, value: datosMun[props.ejes.ejeBrechas.vari.value + "_" + categoria.value], color: colores[i + 2], name: categoria.nombre }])
                                serieBrecha.push({ ...datosMun, category: brecha.nombre, value: datosMun[props.ejes.ejeBrechas.vari.value + "_" + categoria.value], color: colores[i + 2], name: categoria.nombre })
                            })
                            datosLineas.push(serieBrecha)
                        });

                        newDatos.push(datosLineaMun)
                        if (datosLineaMun.length > 0) {
                            leyenda.push({ color: datosLineaMun[0].color, name: datosLineaMun[0].name, value: datosLineaMun[0].value })
                        }

                    }
                }

            }

            // Obtener datos nacional y total pdet
            let reg1 = { id: 0, tipo: "totalPDET", departamento: "Total Nacional", municipio: "Total Nacional", divipola: "00000", data: [], color: "#4d8dd7" }
            let datosPDET = obtenerDatos(props.ejes.ejeBrechas, reg1)

            if (datosPDET) {
                datosPDET = datosPDET.filter(item => item != undefined).filter(item => item.attributes != undefined).map(item => item.attributes)
                let datosNacional = datosPDET.find(item => item.department == "Total Nacional")
                datosPDET = datosPDET.filter(item => item.department != "Total Nacional")

                if (props.ejes.regionBrechas.tipo == "PDET") {
                    ejes.push({ category: "Regiones PDET", labelName: "Sin información", color: colores[0] })
                    let seriePDET = []
                    datosPDET.forEach(dato => {
                        if (dato[props.ejes.ejeBrechas.vari.value] != null) {
                            newDatos.push([{ ...dato, category: "Regiones PDET", value: dato[props.ejes.ejeBrechas.vari.value], color: colores[0], name: dato.department }])
                            seriePDET.push({ ...dato, category: "Regiones PDET", value: dato[props.ejes.ejeBrechas.vari.value], color: colores[0], name: dato.department })
                        }
                    })
                    datosLineas.push(seriePDET)
                }
                if (datosNacional) {

                    // Nacional
                    if (datosNacional[props.ejes.ejeBrechas.vari.value] != null) {

                        // linea
                        let colorLinea = coloresLinea[2]
                        let datosLinea = [
                            { ...datosNacional, category: "Departamentos", value: datosNacional[props.ejes.ejeBrechas.vari.value], color: colorLinea, name: datosNacional.department }
                        ]
                        if (props.ejes.regionBrechas.tipo == "PDET") {
                            datosLinea.push({ ...datosNacional, category: "Regiones PDET", value: datosNacional[props.ejes.ejeBrechas.vari.value], color: colorLinea, name: datosNacional.department })
                        }

                        // Extra brechas
                        props.ejes.ejeBrechas.vari.brechas.forEach((brecha, i) => {
                            ejes.push({ category: brecha.nombre, labelName: "Sin información", color: colores[i + 2] })
                            datosLinea.push({ ...datosNacional, category: brecha.nombre, value: datosNacional[props.ejes.ejeBrechas.vari.value], color: colorLinea, name: datosNacional.department })
                            if (props.ejes.regionBrechas.tipo == "PDET") {
                                let serieBrecha = []
                                brecha.categorias.forEach(categoria => {
                                    newDatos.push([{ ...datosNacional, category: brecha.nombre, value: datosNacional[props.ejes.ejeBrechas.vari.value + "_" + categoria.value], color: colores[i + 2], name: categoria.nombre }])
                                    serieBrecha.push({ ...datosNacional, category: brecha.nombre, value: datosNacional[props.ejes.ejeBrechas.vari.value + "_" + categoria.value], color: colores[i + 2], name: categoria.nombre })
                                })
                                datosLineas.push(serieBrecha)
                            }
                        });

                        newDatos.push(datosLinea)
                        leyenda.unshift({ color: datosLinea[0].color, name: datosLinea[0].name, value: datosLinea[0].value })
                    }
                }
            }
            datosLineas.forEach(linea => {
                if (linea.length > 0) {
                    let vals = linea.filter(item => item.value != null)
                    let max = -Infinity
                    let min = Infinity
                    let maxI = null
                    let minI = null
                    vals.forEach(val => {
                        if (val.value > max) {
                            max = val.value
                            maxI = val
                        }
                        if (val.value < min) {
                            min = val.value
                            minI = val
                        }
                    })
                    let eje = ejes.find(item => item.category == linea[0].category)
                    if (eje) {
                        eje["maxName"] = maxI ? maxI.name : "-"
                        eje["minName"] = minI ? minI.name : "-"
                        eje["maxValue"] = max > -Infinity ? (Math.round((max + Number.EPSILON) * 100) / 100) : "-"
                        eje["minValue"] = min < Infinity ? (Math.round((min + Number.EPSILON) * 100) / 100) : "-"
                        eje["labelName"] = "[bold]Máximo[/]:\n" + (maxI ? (maxI.name + ":") : "-") + " " + (max > -Infinity ? (Math.round((max + Number.EPSILON) * 100) / 100) : "") + "\n\n"
                        eje["labelName"] += "[bold]Mínimo[/]:\n" + (minI ? (minI.name + ":") : "-") + " " + (min < Infinity ? (Math.round((min + Number.EPSILON) * 100) / 100) : "") + "\n\n"
                        let brechaAbs = min < Infinity ? (Math.round((Math.abs(max - min) + Number.EPSILON) * 100) / 100) : "-"
                        let brechaRel = "-"
                        if (min < Infinity && min != 0) {
                            brechaRel = Math.round((Math.abs(max / min) + Number.EPSILON) * 100) / 100
                        }
                        else if (min == 0) {
                            brechaRel = brechaAbs
                        }
                        eje["labelName"] += "[bold]Brecha absoluta[/]:\n" + brechaAbs + "\n\n"
                        eje["labelName"] += "[bold]Brecha relativa[/]:\n" + brechaRel
                        eje["brechaAbs"] = brechaAbs
                        eje["brechaRel"] = brechaRel
                    }
                }
            })
            if (ejes.length > 0 && datosLineas.length > 0) {
                props.graficaBrechas({ ejes: ejes, scatter: newDatos, plot: datosLineas })
            }
            else {
                props.graficaBrechas({ ejes: ejes, scatter: [], plot: [] })
            }

            setLeyendaBrechas(leyenda)
            props.setFuente(props.ejes.ejeBrechas.vari.fuente)
        }
        else {
            let dataTotal = []
            let regionesIndividuales = []
            let regionesGrupales = []
            props.ejes.regiones.forEach(region => {
                if (['PDET', 'dept', 'mun'].includes(region.tipo)) {
                    region.data = []
                    props.ejes.ejes.forEach(eje => {
                        let datos = obtenerDatos(eje, region)
                        if (datos) {

                            if (datos[eje.vari.value] == null) {
                                region.data.push({ ...datos, category: eje.id + ". " + eje.vari.name + " " + eje.year, orgValue: null, value: null, color: region.color, tooltipText: "[bold]" + eje.id + "[/]: -  " })
                            }
                            else {
                                region.data.push({ ...datos, category: eje.id + ". " + eje.vari.name + " " + eje.year, orgValue: datos[eje.vari.value], value: datos[eje.vari.value], color: region.color, tooltipText: "[bold]" + eje.id + "[/]: " + (Math.round((datos[eje.vari.value] + Number.EPSILON) * 100) / 100) + eje.vari.unit + "  " })
                            }
                        }
                        else {
                            region.data.push({ category: eje.id + ". " + eje.vari.name + " " + eje.year, orgValue: null, value: null, color: region.color, tooltipText: "[bold]" + eje.id + "[/]: -  " })
                        }
                    })
                    regionesIndividuales.push(region)
                    dataTotal.push(...region.data)
                }
                else {
                    let datosRegion = []
                    props.ejes.ejes.forEach(eje => {
                        let datos = obtenerDatos(eje, region)
                        if (datos) {
                            datos.forEach(item => {
                                if (item.attributes[eje.vari.value] == null) {
                                    datosRegion.push({ ...item.attributes, category: eje.id + ". " + eje.vari.name + " " + eje.year, orgValue: null, value: null, color: region.color, tooltipText: "[bold]" + eje.id + "[/]:  -  " })
                                }
                                else {
                                    datosRegion.push({ ...item.attributes, category: eje.id + ". " + eje.vari.name + " " + eje.year, orgValue: item.attributes[eje.vari.value], value: item.attributes[eje.vari.value], color: region.color, tooltipText: "[bold]" + eje.id + "[/]: " + (Math.round((item.attributes[eje.vari.value] + Number.EPSILON) * 100) / 100) + eje.vari.unit + "  " })
                                }
                            })
                        }
                    })
                    dataTotal.push(...datosRegion)
                    region.data = combinarDatos(datosRegion)
                    regionesGrupales.push(region)
                }
            })
            let limits = []
            props.ejes.ejes.forEach(eje => {
                eje["category"] = eje.id + ". " + eje.vari.name + " " + eje.year
                eje.orgRange = [...eje.vari.range]
                let min = Math.min(...dataTotal.filter(item => item.category == eje["category"] && item.value).map(o => o.value))
                if (min == Infinity || min == -Infinity) {
                    min = 0
                }
                if (!eje.orgRange[0] && eje.orgRange[0] !== 0) {


                    if (eje.orgLimits[0] > eje.orgLimits[1] && min > eje.orgLimits[1]) {
                        min = eje.orgLimits[1]
                    }
                    else if (eje.orgLimits[0] < eje.orgLimits[1] && min > eje.orgLimits[0]) {
                        min = eje.orgLimits[0]
                    }
                    eje.orgRange[0] = min - Math.abs(min * 0.03)
                }
                else {
                    if (eje.orgRange[0] > min) {
                        eje.orgRange[0] = min - Math.abs(max * 0.03)
                    }
                }
                let max = Math.max(...dataTotal.filter(item => item.category == eje["category"] && item.value).map(o => o.value))
                if (max == Infinity || max == -Infinity) {
                    max = 1
                }
                if (!eje.orgRange[1] && eje.orgRange[1] !== 0) {
                    if (eje.orgLimits[0] < eje.orgLimits[1] && max < eje.orgLimits[1]) {
                        max = eje.orgLimits[1]
                    }
                    else if (eje.orgLimits[0] > eje.orgLimits[1] && max < eje.orgLimits[0]) {
                        max = eje.orgLimits[0]
                    }
                    eje.orgRange[1] = max + Math.abs(max * 0.03)
                }
                else {
                    if (eje.orgRange[1] < max) {
                        eje.orgRange[1] = max + Math.abs(max * 0.03)
                    }
                }
            })
            let ejesVisibles = ajustarMaximoMinimoEjesMismaCategoria(props.ejes.ejes)
            props.ejes.ejes.forEach(eje => {
                dataTotal.filter(item => item.category == eje["category"] && item.value).forEach(item => {
                    item.value = (item.value - eje.orgRange[0]) / (eje.orgRange[1] - eje.orgRange[0])
                })
                if (eje.orgLimits) {
                    let tempLimitsUpper = []
                    let tempLimitsLower = []
                    if (eje.orgLimits[0] > eje.orgLimits[1]) {
                        tempLimitsUpper.push(eje.orgRange[1])
                        tempLimitsUpper.push(eje.orgLimits[0])
                        tempLimitsUpper.push(eje.orgLimits[1])
                        tempLimitsLower.push(eje.orgLimits[0])
                        tempLimitsLower.push(eje.orgLimits[1])
                        tempLimitsLower.push(eje.orgRange[0])
                    }
                    else {
                        tempLimitsUpper.push(eje.orgLimits[0])
                        tempLimitsUpper.push(eje.orgLimits[1])
                        tempLimitsUpper.push(eje.orgRange[1])
                        tempLimitsLower.push(eje.orgRange[0])
                        tempLimitsLower.push(eje.orgLimits[0])
                        tempLimitsLower.push(eje.orgLimits[1])
                    }

                    for (let i = 0; i < tempLimitsUpper.length; i++) {
                        let descripciones = nombresColores[i].nombre
                        if (tempLimitsLower[i] <= tempLimitsLower[0] && tempLimitsLower[i] <= tempLimitsLower[1] && tempLimitsLower[i] <= tempLimitsLower[2]) {
                            descripciones = "[bold]" + eje.vari.titulos[i] + "\n(menor a " + tempLimitsUpper[i] + eje.vari.unit + ") [/]\n" + justify(eje.vari.descripciones[i], 28)
                        }
                        else if (tempLimitsUpper[i] >= tempLimitsUpper[0] && tempLimitsUpper[i] >= tempLimitsUpper[1] && tempLimitsUpper[i] >= tempLimitsUpper[2]) {
                            descripciones = "[bold]" + eje.vari.titulos[i] + "\n(mayor a " + tempLimitsLower[i] + eje.vari.unit + ") [/]\n" + justify(eje.vari.descripciones[i], 28)
                        }
                        else {
                            descripciones = "[bold]" + eje.vari.titulos[i] + "\n(de " + tempLimitsLower[i] + eje.vari.unit + " a " + tempLimitsUpper[i] + eje.vari.unit + ") [/]\n" + justify(eje.vari.descripciones[i], 28)
                        }
                        let newLimit = {
                            category: eje["category"],
                            color: nombresColores[i].color,
                            descripciones: descripciones,
                            valueStart: (tempLimitsLower[i] - eje.orgRange[0]) / (eje.orgRange[1] - eje.orgRange[0]),
                            valueEnd: (tempLimitsUpper[i] - eje.orgRange[0]) / (eje.orgRange[1] - eje.orgRange[0])
                        }
                        limits.push(newLimit)
                    }
                }
                if (eje.vari.descripcion) {
                    eje["orgDesc"] = justify(eje.vari.descripcion, 28)
                }
                else {
                    eje["orgDesc"] = justify(eje["category"], 28)
                }
            })

            const fullSeries = []
            regionesIndividuales.forEach(item => {
                if (item.data.length > 0) {
                    fullSeries.push(item.data)
                }
            })

            regionesGrupales.forEach(item => {
                Object.values(item.data).forEach(series => {
                    if (series.length > 0) {
                        fullSeries.push(series)
                    }
                })
            })
            props.grafica({ ejes: props.ejes.ejes, series: fullSeries.filter((series) => series[0].municipality), limites: limits, ejesVisibles: ejesVisibles })
        }
    }, [props.ejes, props.estado, props.tipoGrafica])


    const opcionesDept = props.estado.departamentos.map(function (x) {
        return ({
            value: x.divipola,
            label: x.nombre
        })
    })
    opcionesDept.unshift({ value: "TODOS", label: "TODOS" })

    const opcionesRegionBrechas = [...opcionesDept]
    opcionesRegionBrechas[0] = { value: "00000", label: "Total Nacional" }

    const opcionesPDET = props.estado.PDET.map(function (x) {
        return ({
            value: x.divipola,
            label: x.nombre
        })
    })
    opcionesPDET.unshift({ value: "TODOS", label: "TODOS" })

    const opcionesMun = []
    Object.entries(props.estado.municipios).forEach(([dept, muns]) => {
        opcionesMun.push(...muns.map(x => {
            return ({
                value: x.divipola,
                label: x.nombre,
                depto: dept
            })
        }))
        opcionesMun.unshift({ value: "TODOS", label: "TODOS", depto: dept })
        opcionesMun.unshift({ value: "--", label: "--", depto: dept })
    })

    function cambiarSelector(newVal) {
        if (newVal.target.value == "true") {
            setSelector(true)
        }
        else {
            setSelector(false)
        }
    }

    function cambiarAnioEje(anio, ejeID) {
        let nuevosEjes = [...props.ejes.ejes]
        let eje = nuevosEjes.find(eje => eje.id == ejeID)
        eje.year = anio
        props.actualizarEjes(nuevosEjes, props.ejes.regiones)
    }

    function cambiarTipoEje(tipo, ejeID) {
        let nuevosEjes = [...props.ejes.ejes]
        let eje = nuevosEjes.find(eje => eje.id == ejeID)
        eje.tipo = tipo
        props.actualizarEjes(nuevosEjes, props.ejes.regiones)
    }

    function cambiarVariableEje(variable, dim, ejeID) {
        let nuevosEjes = [...props.ejes.ejes]
        let eje = nuevosEjes.find(eje => eje.id == ejeID)
        eje.vari = variable
        eje.orgRange = [...variable.range]
        eje.orgLimits = variable.limits ? [...variable.limits] : false
        eje.dimension = dim
        let years = props.direcciones.find(address => address.l == "dept" && address.n == dim).years
        eje.year = years[years.length - 1]
        props.actualizarEjes(nuevosEjes, props.ejes.regiones)
    }

    function eliminarEje(ejeID) {
        let nuevosEjes = [...props.ejes.ejes]
        nuevosEjes = nuevosEjes.filter(eje => eje.id != ejeID)
        nuevosEjes.forEach((eje, i) => {
            eje.id = i + 1
        })
        props.actualizarEjes(nuevosEjes, props.ejes.regiones)
    }

    function nuevoEje() {
        let nuevosEjes = [...props.ejes.ejes]
        let eje = {
            id: nuevosEjes.length + 1, year: 2019, tipo: "dept", vari: {
                name: "Cobertura en educación (total)", value: "total_net_coverage", range: [0, 100], unit: "%", limits: [95, 85],
                titulos: ["Alta cobertura", "Media cobertura", "Baja cobertura"],
                descripciones: [
                    "Tienen el reto de mantener o ampliar la oferta educativa hasta alcanzar la universalidad en el acceso, al igual que enfocar su política pública en mejorar la calidad educativa por medio del análisis de resultados de las pruebas estandarizadas de los estudiantes del municipio.",
                    "Tienen el desafío de seguir ampliando su oferta educativa para lograr la universalidad en el acceso. Las autoridades deben caracterizar a aquella población que se queda por fuera del sistema educativo (por ejemplo, la condición socioeconómica según Sisbén y zona geográfica), para así ampliar la oferta educativa de forma específica.",
                    "Tienen el desafío de ampliar su oferta educativa para cubrir las necesidades de la demanda. Su política pública debe ir enfocada en la creación de cupos educativos por medio de inversión en zonas críticas donde el acceso a cupos puede ser desafiante, como poblaciones más vulnerables y zonas rurales dispersas (si aplica)."
                ],
                descripcion: "El acceso a la educación puede medirse a partir del indicador de cobertura neta, el cual da cuenta de la relación que existe entre el número de estudiantes matriculados en un nivel educativo que tienen la edad teórica para cursarlo y el total de la población correspondiente a esa misma edad en un periodo específico (Ministerio de Educación Nacional, 2013)."
            }, dimension: "BD_25_CNE", orgRange: [0, 100], orgLimits: [95, 85], orgDesc: ""
        }
        nuevosEjes.push(eje)
        props.actualizarEjes(nuevosEjes, props.ejes.regiones)
    }

    function listarEjes() {
        let del = true
        if (props.ejes.ejes.length < 3) {
            del = false
        }
        return props.ejes.ejes.map((eje, i) => {
            return (
                <Eje key={i + 1} eje={eje} del={del} direcciones={props.direcciones} fun={{ cambiarAnioEje, cambiarTipoEje, cambiarVariableEje, eliminarEje }} darkMode={props.darkMode}></Eje>
            )
        })
    }

    function cambiarColorRegion(color, regionID) {
        let nuevasRegiones = [...props.ejes.regiones]
        let region = nuevasRegiones.find(region => region.id == regionID)
        region.color = color
        props.actualizarEjes(props.ejes.ejes, nuevasRegiones)
    }

    function cambiarTipoRegion(tipo, regionID) {
        let nuevasRegiones = [...props.ejes.regiones]
        let region = nuevasRegiones.find(region => region.id == regionID)
        if (tipo == "PDET") {
            region.tipo = "totalPDET"
        }
        else if (tipo == "dept") {
            region.tipo = "totalDept"
        }
        region.departamento = "TODOS"
        region.municipio = "--"
        props.actualizarEjes(props.ejes.ejes, nuevasRegiones)
    }

    function cambiarMunicipioRegion(municipio, regionID) {
        let nuevasRegiones = [...props.ejes.regiones]
        let region = nuevasRegiones.find(region => region.id == regionID)
        region.municipio = municipio
        if (municipio == "TODOS") {
            region.tipo = "totalMun"
        }
        else if (municipio == "--") {
            region.tipo = "dept"
        }
        else {
            region.tipo = "mun"
        }
        props.actualizarEjes(props.ejes.ejes, nuevasRegiones)
    }

    function cambiarDepartamentoRegion(departamento, regionID) {
        let nuevasRegiones = [...props.ejes.regiones]
        let region = nuevasRegiones.find(region => region.id == regionID)
        region.departamento = departamento
        if (region.tipo == "dept" || region.tipo == "totalDept") {
            if (departamento == "TODOS") {
                region.tipo = "totalDept"
            }
            else {
                region.tipo = "dept"
                region.municipio = "--"
            }
        }
        else if (region.tipo == "PDET" || region.tipo == "totalPDET") {
            if (departamento == "TODOS") {
                region.tipo = "totalPDET"
            }
            else {
                region.tipo = "PDET"
            }
        }
        else if (region.tipo == "mun" || region.tipo == "totalMun") {
            if (departamento == "TODOS") {
                region.tipo = "totalDept"
                region.municipio = "--"
            }
            else {
                region.tipo = "dept"
                region.municipio = "--"
            }
        }
        props.actualizarEjes(props.ejes.ejes, nuevasRegiones)
    }

    function eliminarRegion(regionID) {
        let nuevasRegiones = [...props.ejes.regiones]
        nuevasRegiones = nuevasRegiones.filter(region => region.id != regionID)
        nuevasRegiones.forEach((region, i) => {
            region.id = i
        })
        props.actualizarEjes(props.ejes.ejes, nuevasRegiones)
    }

    function nuevaRegion() {
        let nuevasRegiones = [...props.ejes.regiones]
        let region = { id: nuevasRegiones.length, tipo: "PDET", departamento: "Total Nacional", municipio: "Total Nacional", divipola: "00000", data: {}, color: "#4d8dd7" }
        nuevasRegiones.push(region)
        props.actualizarEjes(props.ejes.ejes, nuevasRegiones)
    }

    function listarRegiones() {
        return props.ejes.regiones.map((region, i) => {
            return (
                <Region key={i} region={region} opciones={{ dept: opcionesDept, mun: opcionesMun, PDET: opcionesPDET }} fun={{ cambiarTipoRegion, cambiarDepartamentoRegion, cambiarMunicipioRegion, eliminarRegion, cambiarColorRegion }} darkMode={props.darkMode}></Region>
            )
        })
    }

    function agregar() {
        if (selector) {
            return nuevoEje()
        }
        else {
            return nuevaRegion()
        }
    }

    function mostrarEjesRegiones() {
        if (selector) {
            return listarEjes()
        }
        else {
            return listarRegiones()
        }
    }

    function cambiarAnioEjeBrechas(newVal) {
        let nuevoEje = props.ejes.ejeBrechas
        nuevoEje.year = newVal.value
        props.actualizarEjeBrechas(nuevoEje)
    }

    function cambiarVariableEjeBrechas(newVal) {
        let nuevoEje = props.ejes.ejeBrechas
        nuevoEje.vari = newVal.item
        nuevoEje.orgRange = [...newVal.item.range]
        nuevoEje.dimension = newVal.dim
        let years = props.direcciones.find(address => address.l == "dept" && address.n == newVal.dim).years
        nuevoEje.year = years[years.length - 1]
        props.actualizarEjeBrechas(nuevoEje)
    }

    function cambiarRegionBrechas(newVal) {
        let region = props.ejes.regionBrechas
        region.departamento = newVal.label
        region.municipio = newVal.label
        if (newVal.label == "Total Nacional") {
            region.tipo = "PDET"
        }
        else {
            region.tipo = "dept"
        }
        props.actualizarRegionBrechas(region)
    }

    function cambiarMunBrechas(newVal) {
        let region = props.ejes.regionBrechas
        if (newVal.label == "--") {
            region.municipio = region.departamento
            region.tipo = "dept"
        }
        else {
            region.municipio = newVal.label
            region.tipo = "mun"
        }
        props.actualizarRegionBrechas(region)
    }

    function obtenerAnio() {
        return { value: newProps.ejes.ejeBrechas.year, label: newProps.ejes.ejeBrechas.year }
    }

    function obtenerVar() {
        return { value: newProps.ejes.ejeBrechas.vari.value, label: newProps.ejes.ejeBrechas.vari.name }
    }

    function obtenerRegion() {
        return { value: newProps.ejes.regionBrechas.divipola, label: newProps.ejes.regionBrechas.departamento }
    }

    function obtenerMun() {
        return { value: newProps.ejes.regionBrechas.divipola, label: newProps.ejes.regionBrechas.municipio }
    }

    function obtenerMunS() {
        if (newProps.ejes.regionBrechas.tipo == 'dept') {
            return { value: '--', label: '--' }
        }
        else {
            return { value: newProps.ejes.regionBrechas.municipio, label: newProps.ejes.regionBrechas.municipio }
        }
    }

    function mostrarMunicipios() {
        if (newProps.ejes.regionBrechas.tipo == 'dept' || newProps.ejes.regionBrechas.tipo == 'mun') {
            let opciones = opcionesMun.filter(item => item.depto == newProps.ejes.regionBrechas.departamento)
            opciones.splice(1, 1)
            return (<div className="col-md-12 col-sm-12 col-xs-12">
                <label className="form-label">Municipio</label>
                <Select
                    bsPrefix="form-control-sm"
                    options={opciones}
                    closeMenuOnSelect={true}
                    onChange={cambiarMunBrechas}
                    value={obtenerMunS()}
                    theme={props.darkMode ? (theme) => ({
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary: '#646a70',
                            primary25: '#444a50',
                            primary50: '#545a60',
                            neutral0: '#343a40',
                            neutral80: '#fff',
                            neutral100: '#fff',
                        },
                    }) : null}
                />
            </div>)
        }
    }

    function generarLeyendaBrechas() {
        return leyendaBrechas.map((item, i) => {
            return <div key={i}><span style={{ backgroundColor: item.color }}></span> {item.name}: {Math.round((item.value + Number.EPSILON) * 100) / 100} <br /></div>
        })
    }

    function mostrarLeyendaBrechas() {
        if (newProps.ejesBrechas.ejes.length > 0 && newProps.ejesBrechas.plot.length > 0) {
            return (<>
                <h6>Leyenda:</h6>
                <div className="rating">
                    {generarLeyendaBrechas()}
                </div>
            </>)
        }
        else {
            return (<>
                <strong>Sin información de {obtenerVar()['label']} - {obtenerAnio()['label']} para {obtenerMun()['label']}.</strong>
                <br />
                <small>La información puede tardar unos segundos en cargarse dependiendo de la velocidad y estabilidad de la red...</small>
            </>)
        }
    }

    function mostrarAyudaTablaBrechas() {
        if (props.tipoGrafica == "brechas" && newProps.ejesBrechas.ejes.length > 0 && newProps.ejesBrechas.plot.length > 0) {
            return (
                <div className="col align-self-end text-center">
                    <img src={arrow} className="rounded mx-auto plus-icon" alt="..."></img>&nbsp;&nbsp;Tabla de brechas abajo
                </div>
            )
        }
    }

    function mostrarSelectorEjes() {
        if (props.tipoGrafica != "brechas") {
            return (<>
                <br />
                <form className="row g-3">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <strong>Mostrar:</strong><br />
                        <Form.Check
                            inline
                            value={true}
                            type={"radio"}
                            id={"default-radio"}
                            label={"Variables"}
                            name="tootltips"
                            onChange={cambiarSelector}
                            checked={selector}
                        />
                        <Form.Check
                            inline
                            value={false}
                            type={"radio"}
                            id={"default-radio"}
                            label={"Regiones"}
                            name="tootltips"
                            onChange={cambiarSelector}
                            checked={!selector}
                        />
                    </div>
                    <hr />
                </form>
                {/* <div className="row g-scrollH" style={{ overflowY: "scroll", maxHeight: "70vh" }} */}
                <div className="row g-3">
                    <Accordion defaultActiveKey="1" variant="dark">
                        {mostrarEjesRegiones()}
                    </Accordion>
                </div>
                <br />
                <div className="text-center boton">
                    <button className="btn btn-default" onClick={agregar}>
                        <img src={plus} className="rounded mx-auto d-block plus-icon" alt="..."></img>Agregar
                    </button >
                </div>

            </>
            )
        }
        else {
            if (props.ejes.ejeBrechas && newProps.ejes.ejeBrechas) {
                let opcionesVariables = []
                props.direcciones.filter(address => address.l == "dept").forEach(item => {
                    opcionesVariables.push(...item.fields.filter(x => x.mostrarBrechas).map(x => {
                        return ({
                            value: x.value,
                            label: x.name,
                            item: { ...x, range: [...x.range] },
                            dim: item.n
                        })
                    }))
                })

                let optionsYear = []
                props.direcciones.find(address => address.l == "dept" && address.n == props.ejes.ejeBrechas.dimension).years.map(year => {
                    optionsYear.push({
                        value: year,
                        label: year
                    })
                })

                return (<>
                    <br />
                    <h5>{obtenerVar()['label']}</h5>
                    <h6>{obtenerAnio()['label']}</h6>
                    <h6>Brechas para: <strong>{obtenerMun()['label']}</strong></h6>
                    <hr />

                    <h6>Selección de variable:</h6>
                    <form className="row g-3 px-2 py-2">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <label className="form-label">Año</label>
                            <Select
                                bsPrefix="form-control-sm"
                                options={optionsYear}
                                closeMenuOnSelect={true}
                                onChange={cambiarAnioEjeBrechas}
                                value={obtenerAnio()}
                                defaultValue={obtenerAnio()}
                                theme={props.darkMode ? (theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary: '#646a70',
                                        primary25: '#444a50',
                                        primary50: '#545a60',
                                        neutral0: '#343a40',
                                        neutral80: '#fff',
                                        neutral100: '#fff',
                                    },
                                }) : null}
                            />
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <label className="form-label">Variable</label>
                            <Select
                                bsPrefix="form-control-sm"
                                options={opcionesVariables}
                                closeMenuOnSelect={true}
                                onChange={cambiarVariableEjeBrechas}
                                value={obtenerVar()}
                                defaultValue={obtenerVar()}
                                theme={props.darkMode ? (theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary: '#646a70',
                                        primary25: '#444a50',
                                        primary50: '#545a60',
                                        neutral0: '#343a40',
                                        neutral80: '#fff',
                                        neutral100: '#fff',
                                    },
                                }) : null}
                            />
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <label className="form-label">Region</label>
                            <Select
                                bsPrefix="form-control-sm"
                                options={opcionesRegionBrechas}
                                closeMenuOnSelect={true}
                                onChange={cambiarRegionBrechas}
                                defaultValue={obtenerRegion()}
                                theme={props.darkMode ? (theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary: '#646a70',
                                        primary25: '#444a50',
                                        primary50: '#545a60',
                                        neutral0: '#343a40',
                                        neutral80: '#fff',
                                        neutral100: '#fff',
                                    },
                                }) : null}
                            />
                        </div>
                        {mostrarMunicipios()}
                    </form>
                    <hr />
                    {mostrarLeyendaBrechas()}
                    <br />
                </>)
            }
        }
    }


    return (
        <>
            <div className="container-fluid ps-1 pe-0 columnextent">
                {mostrarSelectorEjes()}
            </div>
            {mostrarAyudaTablaBrechas()}
        </>
    )
}

export default Ejes;